import { useEffect, useState } from 'react';
import axios, { AxiosError } from 'axios';
import { LinearLoader } from '@shared/components/grid/overlays/components/LinearLoader';

export const AppLoader = () => {
  const [loading, setLoading] = useState(false);
  const isMethodSupported = (method?: string) => ['patch', 'put', 'get'].includes(String(method));

  useEffect(() => {
    const handleError = (error: AxiosError | Error) => {
      setLoading(false);
      return Promise.reject(error);
    };

    const requestInterceptor = axios.interceptors.request.use((config) => {
      if (isMethodSupported(config?.method)) {
        setLoading(true);
      }

      return config;
    }, handleError);

    const responseInterceptor = axios.interceptors.response.use((response) => {
      if (isMethodSupported(response?.config?.method)) {
        setLoading(false);
      }

      return response;
    }, handleError);

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  return loading ? <LinearLoader /> : null;
};
